import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
var Line = function Line(props) {
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls,
    prefixCls = _useContext.prefixCls;
  var left = props.left,
    width = props.width,
    className = props.className;
  var activeLinePrefixCls = getPrefixCls(prefixCls, 'active-line');
  var activeLineClasses = classNames(activeLinePrefixCls, className, {
    // [`${tabPanePrefixCls}-size-${size}`]: size, // 尺寸样式
    // [`${tabPanePrefixCls}-disabled`]: disabled || loadingDisabled, // 禁用态样式
    // [`${tabPanePrefixCls}-loading`]: loading, // 加载中样式
  });
  var activeLineStyle = {
    left: "".concat(left, "px"),
    width: "".concat(width, "px")
  };
  return /*#__PURE__*/React.createElement("span", {
    className: activeLineClasses,
    style: activeLineStyle
  });
};
Line.displayName = 'Line';
export default Line;